import { format } from 'date-fns'

export default {
  role () {
    if (this.user?.roles?.includes('ROLE_ADMIN')) {
      return 'Administrador'
    }

    if (this.user?.roles?.includes('ROLE_TEACHER')) {
      return 'Professor'
    }

    if (this.user?.roles?.includes('ROLE_STUDENT')) {
      return 'Aluno'
    }

    return null
  },

  calendarEvents () {
    return this.user.schedules.map(function (item) {
      const start = new Date(item.start)
      const end = new Date(item.end)

      return {
        name: `${item.available ? 'Disponível' : 'Agendado'}: ${format(start, 'HH:mm')} - ${format(end, 'HH:mm')}`,
        color: item.available ? 'green' : 'red lighten-1',
        start: start,
        end: end,
      }
    })
  },
}
